import * as en from '@/locales/en-US';
import * as zh from '@/locales/zh-CN';
import { getLocale } from 'umi/locale';

function formatMessage({ id }) {
  if (getLocale() === 'zh-CN') {
    return zh.default[id] ? zh.default[id] : id
  } else if (getLocale() === 'en-US') {
    return en.default[id] ? en.default[id] : id
  } else {
    return null
  }
}
export const orgType = {
  heading: {
    name: 'HEADING',
    caption: formatMessage({ id: '海鼎' })
  },
  company: {
    name: 'COMPANY',
    caption: formatMessage({ id: '企业' })
  },
  dc: {
    name: 'DC',
    caption: formatMessage({ id: '配送中心' })
  },
  carrier: {
    name: 'CARRIER',
    caption: formatMessage({ id: '承运商' })
  },
  vendor: {
    name: 'VENDOR',
    caption: formatMessage({ id: '供应商' })
  },
  store: {
    name: 'STORE',
    caption: formatMessage({ id: '门店' })
  },
  owner: {
    name: 'OWNER',
    caption: formatMessage({ id: '货主' })
  }
}

export function getOrgCaption(name) {
  const actOrgType = {
    heading: {
      name: 'HEADING',
      caption: formatMessage({ id: '海鼎' })
    },
    company: {
      name: 'COMPANY',
      caption: formatMessage({ id: '企业' })
    },
    dc: {
      name: 'DC',
      caption: formatMessage({ id: '配送中心' })
    },
    carrier: {
      name: 'CARRIER',
      caption: formatMessage({ id: '承运商' })
    },
    vendor: {
      name: 'VENDOR',
      caption: formatMessage({ id: '供应商' })
    },
    store: {
      name: 'STORE',
      caption: formatMessage({ id: '门店' })
    },
    owner: {
      name: 'OWNER',
      caption: formatMessage({ id: '货主' })
    }
  }
  let caption;
  for (let x in actOrgType) {
    if (actOrgType[x].name === name) {
      caption = actOrgType[x].caption;
      break;
    }
  }

  return caption;
}
